import {
  EVerifyPhoneError,
  verifyPhoneRequestStartAction,
  verifyPhoneSetErrorMessageAction,
} from '@cian/sms-validation-widget';
import { ThunkAction } from 'redux-thunk';
import { IContext, IState } from '../index';
import { ICreateMessageForOfferRequest } from '../../repositories/demand/v2/create-message-for-offer';
import { demandLastRequestedData } from '@cian/demand-trap-widget';
import { trackVerificationPhoneError, trackVerifyPhone } from '../../components/demand/utils/tracking';
import { sendDemandRequest } from '../demand/demandThunk';

export const verifyPhoneRequest = (sms: string): ThunkAction<void, IState, IContext> => {
  return (dispatch, getState) => {
    dispatch(verifyPhoneRequestStartAction(sms));

    const state = getState();
    const lastRequestedDemandData: ICreateMessageForOfferRequest = demandLastRequestedData(state);

    trackVerifyPhone(Boolean(lastRequestedDemandData.isHomeowner));

    if (!sms) {
      trackVerificationPhoneError(Boolean(lastRequestedDemandData.isHomeowner));
      dispatch(verifyPhoneSetErrorMessageAction(EVerifyPhoneError.NOT_CORRECT));
    } else {
      dispatch(sendDemandRequest({ ...lastRequestedDemandData, confirmationCode: sms, source: 'Card' }));
    }
  };
};
